import {
  BE_BASE_URL,
  BE_COURSES_ENDPOINT,
  BE_COURSE_CATALOG_ENDPOINT,
} from "../../utils/config";
import { CorsoType, CourseCarouselItem, CoursePage } from "../../types";
import { toast } from "react-toastify";
import i18n from "i18next";
import { axiosInstance } from "../../provider/authProvider";
import { goToPage } from "../../utils/utils";
import { messaggioDiRifiuto } from "../user/solaLettura";

export function getCourseById(courseId: string) {
  try {
    const axiosResponse = axiosInstance.get<CoursePage>(
      BE_BASE_URL + BE_COURSES_ENDPOINT + "courseByUserAndId",
      {
        params: {
          courseCode: courseId,
        },
      }
    );
    return axiosResponse
      .then((response) => response.data)
      .catch((response) => {
        if (response.status === 404) {
          goToPage("not-found");
          return undefined;
        }
      });
  } catch {
    goToPage("500");
  }
}

export function getAvailableCourses() {
  try {
    const axiosResponse = axiosInstance.get<CourseCarouselItem[]>(
      BE_BASE_URL + BE_COURSES_ENDPOINT + "coursesByUser"
    );
    return axiosResponse.then((response) => response.data);
  } catch {
    goToPage("500");
  }
}

// Il catalogo corsi (codice -> nome a catalogo): è il solo nome con cui si
// filtra per corso nelle tab attestati. Se fallisce, il filtro corso non trova
// nulla ma la lista resta visibile: toast e catalogo vuoto.
export function getCourseCatalog(): Promise<Map<string, string>> {
  return (
    axiosInstance
      .get<CorsoType[]>(BE_BASE_URL + BE_COURSE_CATALOG_ENDPOINT)
      .then(
        (response) =>
          new Map(
            (response.data ?? []).map((corso) => [corso.code, corso.name])
          )
      )
      .catch(() => {
        toast.error(i18n.t("attestati-errore-catalogo"));
        return new Map<string, string>();
      })
  );
}

// Assegna un dipendente a un corso mancante (cf) o ne annulla l'assegnazione
// (null). Ritorna false se il backend rifiuta: chi chiama non aggiorna lo
// stato locale.
export function assignMissingCourse(
  courseMissingId: number,
  cf: string | null
): Promise<boolean> {
  return axiosInstance
    .put(BE_BASE_URL + BE_COURSES_ENDPOINT + "missings/" + courseMissingId, {
      cf,
    })
    .then(() => true)
    .catch((errore: unknown) => {
      toast.error(
        messaggioDiRifiuto(errore, i18n.t("attestati-errore-assegnazione"))
      );
      return false;
    });
}
